import { render, staticRenderFns } from "./QrCodePix.vue?vue&type=template&id=efb45eee&scoped=true"
import script from "./QrCodePix.vue?vue&type=script&lang=js"
export * from "./QrCodePix.vue?vue&type=script&lang=js"
import style0 from "./QrCodePix.vue?vue&type=style&index=0&id=efb45eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb45eee",
  null
  
)

export default component.exports